<template>
  <footer class="footer">
     <div class="container">
       <div class="row">
         <div class="col-md-4 order-2 order-md-1">
           <div class="text-center text-md-start">
             <div class="widget_block">
               <a href="https://play.google.com/store/apps/details?id=com.barn.promomatik.cekkazan&hl=en&gl=US" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="https://cekkazan.com.tr/images/svg/google-play.svg"
                   alt=""
               /></a>
               <a href="https://apps.apple.com/tr/app/%C3%A7ek-kazan/id1175448426" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="https://cekkazan.com.tr/images/svg/app-store.svg"
                   alt=""
               /></a>
               <a href="https://appgallery.huawei.com/app/C101761361" class="item_widget"
                 ><img
                   class="widget_img img-fluid"
                   src="https://cekkazan.com.tr/images/svg/appgallery.svg"
                   alt=""
               /></a>
             </div>
           </div>
         </div>
         <div class="col-md-4 order-1 order-md-3">
           <div class="text-center text-md-end">
             <h5 class="h5 color-white fw-600">Politikalarımız</h5>
             <ul class="footer_links">
               <li>
                 <a href="https://cekkazan.com.tr/firma-gizlilik-politikasi" class="text_sm color-white">Gizlilik Politikası</a>
               </li>
               <li>
                 <a href="https://cekkazan.com.tr/kullanim-kosullari" class="text_sm color-white">Kullanım Koşulları</a>
               </li>
               <li>
                 <a href="https://cekkazan.com.tr/acik-riza-metni" class="text_sm color-white">Açık Rıza Metni</a>
               </li>
               <li>
                 <a href="https://cekkazan.com.tr/uye-aydinlatma-metni" class="text_sm color-white">Üye Aydınlatma Metni</a>
               </li>
             </ul>
           </div>
         </div>
         <div class="col-md-4 order-3 order-md-2">
           <div class="text-center">
             <div class="logo_footer mt-3 mb-3">
                 <a href="https://justsnap.de/"><img class="img-fluid" src="https://cekkazan.com.tr/images/png/justsnap-logo.png" alt=""></a>
             </div>
             <div class="text_sm color-white mb-3">
               Powered by :
               <a href="https://justsnap.co/" class="color-white">Justsnap</a> Teknoloji A.Ş.
             </div>
             <div class="wrapper_social_btn wrapper_social_btn_footer">
                 <a href="https://www.facebook.com/cekkazan/" class="social_btn"><i class="lab la-facebook-f"></i></a>
                 <a href="https://www.instagram.com/cekkazan/" class="social_btn"><i class="lab la-instagram"></i></a>
                 <a href="https://www.youtube.com/cekkazan" class="social_btn"><i class="lab la-youtube"></i></a>
             </div>
           </div>
         </div>
       </div>
     </div>
   </footer>
</template>

<style>
.campaign-footer {
  background-color: #ea5610;
  color: white;
  text-align: center;
  padding: 2rem 1rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  border-top: 4px solid #d14e0e;
}

.footer-logo {
  max-width: 150px;
  margin-bottom: 1rem;
}

.campaign-footer p {
  margin: 0;
  font-weight: 500;
}

.footer-links {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
}
.footer-link {
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}
.footer-link:hover {
  color: #f9d4c3;
}
@media (max-width:991px){
  ul.footer_links {
    padding-left: 0px;
    color: rgb(168, 168, 168)!important;
}
}
</style>
